import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Heart, MapPin } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { useDonate } from '../donate/DonateContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DonorWall = () => {
  const { t } = useLanguage();
  const { openDonate } = useDonate();
  const [donors, setDonors] = useState([]);

  useEffect(() => {
    axios.get(`${API}/donations/wall`).then((res) => setDonors(res.data || [])).catch(() => {});
  }, []);

  if (donors.length === 0) return null;
  return (
    <section className="jbss-wall-section" data-testid="donor-wall">
      <div className="jbss-container">
        <div className="jbss-wall-head">
          <div>
            <h2 className="jbss-wall-title">{t('wall.title')}</h2>
            <p className="jbss-wall-sub">{t('wall.subtitle')}</p>
          </div>
          <button className="jbss-btn jbss-btn-gold" onClick={openDonate} data-testid="donor-wall-donate">
            <Heart size={16} fill="currentColor" /><span>{t('nav.donate')}</span>
          </button>
        </div>
        <ul className="jbss-wall-list">
          {donors.map((d, i) => (
            <li key={`${d.first_name}-${i}`} className="jbss-wall-chip" style={{ animationDelay: `${i * 60}ms` }} data-testid={`donor-wall-item-${i}`}>
              <Heart size={14} fill="currentColor" className="jbss-wall-heart" />
              <strong>{d.first_name}</strong>
              {d.place && <span><MapPin size={12} />{d.place}</span>}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default DonorWall;
